import PeriodDisplay from "connected-components/dashboard/components/period-display"
import { DRIFT_DATES_SHAPE } from "../../prop-types"

export default function RiskHeader({ driftDates }) {
  return <PeriodDisplay isPerformance={false} driftDates={driftDates} label="Drift Period" />
}

RiskHeader.propTypes = {
  driftDates: DRIFT_DATES_SHAPE,
}
